// extracted by mini-css-extract-plugin
export default {"root":"SectionHeader_root__EwM0U","center":"SectionHeader_center__xeObW","subtitle":"SectionHeader_subtitle__XSjqh"};